import { render } from "./WizardStep2.pug?vue&type=template&id=6f97d47e&lang=pug"
import script from "./WizardStep2.js?vue&type=script&lang=js"
export * from "./WizardStep2.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__